import { SpecialFreightIdView } from '../../../../models';

export class ShipmentSpecialFreightTrackingMapLoad {
  public static readonly type = '[ShipmentSpecialFreightTrackingMap] Load';
  constructor(public payload: SpecialFreightIdView) {}
}

export class ShipmentSpecialFreightTrackingMapInitialState {
  public static readonly type = '[ShipmentSpecialFreightTrackingMap] Set Initial State';
}
